<template>
	<div>
		<el-form ref="form" :model="queryParams" :rules="rules" label-width="100px" label-position="right">
			<el-row class="row-content">
				<el-col :span="7">
					<el-form-item label="申办类型" prop="sbsxType">
						<el-select v-model="queryParams.sbsxType" size="medium" clearable>
						  <el-option
							v-for="item in sblxOptions"
							:key="item.dictValue"
							:label="item.dictLabel"
							:value="item.dictValue">
						  </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="7">
					<el-form-item label="提交状态:" prop="status">
						<el-select v-model="queryParams.ywSaveStatus" size="medium" clearable>
<!--						  <el-option-->
<!--							v-for="item in tjztOptions"-->
<!--							:key="item.dictValue"-->
<!--							:label="item.dictLabel"-->
<!--							:value="item.dictValue">-->
<!--						  </el-option>-->
							<el-option label="已提交" value="Y"></el-option>
							<el-option label="已保存" value="N"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="7">
					<el-form-item label="受理状态:" prop="acceptStatus">
						<el-select v-model="queryParams.ywAuditStatus" size="medium" clearable>
<!--						  <el-option-->
<!--							v-for="item in slztOptions"-->
<!--							:key="item.dictValue"-->
<!--							:label="item.dictLabel"-->
<!--							:value="item.dictValue">-->
<!--						  </el-option>-->
							<el-option label="待受理" value="1"></el-option>
							<el-option label="已受理" value="2"></el-option>
							<el-option label="已办结" value="3"></el-option>
							<el-option label="已退回" value="4"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="3" style="line-height: 2.25rem;padding-left:1rem;">
					<el-button type="primary" size="small" @click="getList">搜 索</el-button>
				</el-col>
			</el-row>
		</el-form>

		<el-row class="content">
			<el-table v-loading="loading" :data="list" ref="table"
			:header-cell-style="{backgroundColor:'#e2e2e2'}" style="width: 100%">
<!--				<el-table-column label="序号" type="index" width="50" />-->
				<el-table-column label="申办事项类型" align="center" prop="sbsxType" :show-overflow-tooltip="true" :formatter="sbsxTypesFormat"/>
				<el-table-column label="申办事项名称" align="center" prop="sbsxName" :show-overflow-tooltip="true"/>
				<el-table-column label="提交状态" align="center" prop="ywSaveStatus"/>
				<el-table-column label="提交/撤销时间" align="center" prop="submitTime">
					<template slot-scope="scope">
						{{parseTime(scope.row.submitTime, '{y}-{m}-{d}')}}
					</template>
				</el-table-column>
				<el-table-column label="受理状态" align="center" prop="ywAuditStatus"/>
				<el-table-column label="受理时间" align="center" prop="acceptTime" />
				<el-table-column label="操作" align="center" width="180">
					<template slot-scope="scope">
						<el-button v-if="scope.row.ywSaveStatus=='已提交'&&scope.row.ywAuditStatus=='待受理'" size="mini" type="text" @click="toRevoke(scope.row)">撤销</el-button>
						<el-button v-if="scope.row.ywSaveStatus=='已保存'" size="mini" type="text" @click="toEdit(scope.row)">编辑</el-button>
						<el-button v-if="scope.row.ywSaveStatus=='已保存'" size="mini" type="text" @click="toSubmit(scope.row)">提交</el-button>
						<el-button size="mini" type="text" @click="toogleExpand(scope.row)">查看</el-button>
					</template>
				</el-table-column>

				<!-- 展开部分 -->
				<el-table-column type="expand" width="1">
					<template slot-scope="scope">
						<el-form label-position="left" inline class="demo-table-expand" style="background-color: #f8f8ff;" v-if="scope.row.sbsxType !== '4'">
							<div v-for="(item,index) in chatLogs" :key="index" class="for-content">
								<el-row>
									<el-col :span="24" class="chat-time">
										<span style="margin-right: 0.5rem;">■</span>
										<span>{{parseTime(item.operateTime,'{y}-{m}-{d} {h}:{i}:{s}')}}</span>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="24" class="chat-content">
										<span>操作：{{item.remark}}</span><br>
										<span v-if="item.remark!='企业提交操作'">意见：{{item.opIdea}}</span>
									</el-col>
								</el-row>
								<el-row class="orgname">
									<el-col :span="24">
										<span>操作人：{{item.operateBy}}</span>
									</el-col>
								</el-row>
							</div>
						</el-form>
						<el-form label-position="left" inline class="demo-table-expand" style="background-color: #f8f8ff;" v-if="scope.row.sbsxType === '4'">
							<div class="for-content">
								<el-row>
									<el-col :span="12" class="chat-col">
										<span>样品编号：</span>
										<span>{{ywzxsqOperation.sampleCode}}</span>
									</el-col>
									<el-col :span="12" class="chat-col">
										<span>约定完成日期：</span>
										<span>{{ywzxsqOperation.agreedFinishDate}}</span>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12" class="chat-col">
										<span>检验结果：</span>
										<span>{{ywzxsqOperation.insResult}}</span>
									</el-col>
									<el-col :span="12" class="chat-col">
										<span>检验日期：</span>
										<span>{{ywzxsqOperation.insDate}}</span>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12" class="chat-col">
										<span>检验费用：</span>
										<span>{{ywzxsqOperation.insMoney}}</span>
									</el-col>
									<el-col :span="12" class="chat-col">
										<span>受理人：</span>
										<span>{{ywzxsqOperation.acceptName}}</span>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12" class="chat-col">
										<span>受理日期：</span>
										<span>{{ywzxsqOperation.acceptDate}}</span>
									</el-col>
									<el-col :span="12" class="chat-col">
										<span>受理状态：</span>
										<span>{{ywzxsqOperation.acceptState}}</span>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12" class="chat-col">
										<span>受理意见：</span>
										<span>{{ywzxsqOperation.acceptIdea}}</span>
									</el-col>
								</el-row>
							</div>
						</el-form>
					</template>
				</el-table-column>
			</el-table>

			<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="getList" />

			<!--回复内容-->
			<el-dialog :title="replyOptions.title" :visible.sync="replyOptions.replyOpen" width="600px" append-to-body>
			  <el-form ref="form" :model="replyForm" :rules="replyOptions.replyRules" label-width="100px">
				<el-row>
				  <el-col :span="24">
					<el-form-item label="回复内容" prop="chReason">
					  <el-input type="textarea" v-model="replyForm.replyContent" placeholder="请输入内容"
								:autosize="{ minRows: 4, maxRows: 6}"/>
					</el-form-item>
				  </el-col>
				</el-row>
			  </el-form>
			  <div slot="footer" class="dialog-footer">
				<el-button type="success" @click="submitReply(replyForm.chatRecid)">提 交</el-button>
				<el-button @click="cancel">取 消</el-button>
			  </div>
			</el-dialog>
		</el-row>
	</div>
</template>

<script>
	import {
		getListDept
	} from "@/api/system/dept"
	import { updateMarket } from "@/api/zscq/market";
	import { updateZyrzfwsb } from "@/api/zscq/zyrzfwsb";
	import { updateQyzpxx } from "@/api/xwqy/qyzpxx";
	import { updateRzsqsx } from "@/api/xwqy/rzsqsx";
	import { updateYwzxsq } from "@/api/jyjcfw/ywzxsq";
	import { listSbsxcx } from "@/api/qygzs/sbsxcx";
	import { update1to1sqxx } from "@/api/zlts/bzfw/1to1sqxx";
	import { listOperation } from "@/api/basedata/YwAuditOperation";
	import { getYwzxsqOperation } from "@/api/jyjcfw/ywzxsqoperation";
	import { updateYlqxsb,submitYlqxsb,getYlqxsb } from "@/api/zlts/rzfw/ylqx";
	export default {
		name: 'qygzsSbsxcx',
		data(){
			return{
				sblxOptions:[],
				tjztOptions:[],
				slztOptions:[],
				// 遮罩层
				loading: false,
				// 总条数
				total: 0,
				list: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					sbsxType:undefined,
					status:undefined,
					acceptStatus:undefined,
					ywFwjgRecid:undefined,
				},
				rules: {

				},
				chatLogs:[],
				replyOptions: {
				  title: '回复信息',
				  replyOpen: false,
				  replyRules:{
				    replyContent: [
				      { required: true, message: '请输入回复信息', trigger: 'blur' },
				      { min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur' }
				    ],
				  },
				},
				replyForm:{
					chatRecid:undefined,
					replyContent:undefined
				},
				form:{

				},
				ywzxsqOperation:{}
			}
		},
		created() {
			this.loginUser = JSON.parse(localStorage.getItem("sdtyfwpt_loginuser"));
			if(this.loginUser != null && this.loginUser != undefined){
				this.queryParams.ywFwjgRecid = this.loginUser.ywFwjgRecid;
			}
			this.getDict();
			this.getList();
		},
		methods:{
			getDict(){
				this.getDicts("yw_sbsxcx_sblx").then(response => {
				    this.sblxOptions = response.data;
				});
				this.getDicts("yw_sbsxcx_tjzt").then(response => {
				    this.tjztOptions = response.data;
				});
				this.getDicts("yw_sbsxcx_slzt").then(response => {
				    this.slztOptions = response.data;
				});
			},
			toPage(url) {
				this.utils.windowOpen(url);
			},
			sbsxTypesFormat(row, column) {
				return this.selectDictLabel(this.sblxOptions, row.sbsxType);
			},
			getList() {
				this.loading = true;
				listSbsxcx(this.queryParams).then(response => {
					this.list = response.rows;
					// console.log(this.list)
					this.total = response.total;
					this.loading = false;
				});
			},
			replyModal(item){
				this.replyOptions.replyOpen = true;
				this.replyForm.chatRecid = item.recid;
			},
			submitReply(chatRecid) {
				this.msgSuccess("提交成功");
				this.replyOptions.replyOpen = false;
			},
			cancel(){
				this.replyForm.replyContent = undefined;
				this.replyOptions.replyOpen = false;
			},
			/**
			 * 撤销 指的是 我提交的数据，到了后台，
			 * 后台工作人员没有进行初审，那么我就可以撤回，
			 * 如果已经初审了，就不能撤销了 撤销后，就是暂存状态 不是提交状态了
			 */
			toRevoke(row){
				//专利转让发布的更改
				if (row.sbsxType==='0') {
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'N';
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					updateMarket(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("撤销成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
				//质押融资申报的更改
				else if (row.sbsxType==='1'){
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'N';
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					updateZyrzfwsb(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("撤销成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
				//招聘信息发布的更改
				else if (row.sbsxType==='2'){
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'N';
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					updateQyzpxx(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("撤销成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
				//专利转让发布的更改
				else if (row.sbsxType==='3'){
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'N';
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					updateRzsqsx(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("撤销成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
				//专利转让发布的更改
				else if (row.sbsxType==='4'){
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'N';
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					updateYwzxsq(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("撤销成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
				//一对一发布的更改
				else if (row.sbsxType==='5'){
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'N';
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					update1to1sqxx(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("撤销成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}//医疗器械产品注册资料预审撤销
				else if (row.sbsxType==='6'){
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'N';
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					updateYlqxsb(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("撤销成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
			},
			//编辑
			toEdit(row){
				if (row.sbsxType==='0') {
					this.utils.windowOpen('/main/zscqzhfw/zscqcsRecord/'+row.recid);
				} else if (row.sbsxType==='1'){
					this.utils.windowOpen('/main/zscqzhfw/zyrzfwSb/'+row.recid);
				} else if (row.sbsxType==='2'){
					this.utils.windowOpen('/main/xwqyczfw/zpxqfbForm/'+row.recid);
				} else if (row.sbsxType==='3'){
					this.utils.windowOpen('/main/xwqyczfw/xqsq/'+row.recid);
				} else if (row.sbsxType==='4'){
					this.utils.windowOpen('/main/jyjcfw/cpzljc/'+row.recid);
				} else if (row.sbsxType==='5'){
					this.utils.windowOpen('/main/bzfw/apply/'+row.recid);
				}
				else if (row.sbsxType==='6'){
					// sessionStorage.clear();

					sessionStorage.removeItem("indexToRzfwRegContent");
					sessionStorage.removeItem("indexToRzfwCode");
					// sessionStorage.removeItem("indexToRzfwRecid");
					// getYlqxsb(row.recid).then(response =>{
					// 	console.log("response",response.data)
					// 	sessionStorage.setItem("indexToRzfwRegContent",response.data.regContent);
					// });
					sessionStorage.setItem("indexToRzfwCode","0601");
					sessionStorage.setItem("indexToRzfwRecid",row.recid);
					// console.log("sessionStorage",sessionStorage)
					this.utils.windowOpen('/main/zltszhfw/rzfw');
				}
			},
			/**
			 * 提交指的是把这条数据 直接提交后，变为待初审，这样后台人员就能看到这条信息，并进行初审 终审了
			 */
			toSubmit(row){
				//专利转让发布的更改
				if (row.sbsxType==='0') {
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'Y';
					this.form.ywAuditStatus = 1;
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					updateMarket(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("提交成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
				//质押融资申报的更改
				else if (row.sbsxType==='1'){
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'Y';
					this.form.ywAuditStatus = 1;
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					updateZyrzfwsb(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("提交成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
				//招聘信息发布的更改
				else if (row.sbsxType==='2'){
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'Y';
					this.form.ywAuditStatus = 1;
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					updateQyzpxx(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("提交成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
				//专利转让发布的更改
				else if (row.sbsxType==='3'){
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'Y';
					this.form.ywAuditStatus = 1;
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					updateRzsqsx(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("提交成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
				//专利转让发布的更改
				else if (row.sbsxType==='4'){
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'Y';
					this.form.ywAuditStatus = 1;
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					updateYwzxsq(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("提交成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
				//一对一发布的更改
				else if (row.sbsxType==='5'){
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'Y';
					this.form.ywAuditStatus = 1;
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					update1to1sqxx(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("提交成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}else  if (row.sbsxType==='6'){
					this.form.recid = row.recid;
					this.form.ywSaveStatus = 'Y';
					this.form.ywAuditStatus = 1;
					this.form.ywFwjgRecid = row.ywFwjgRecid;
					submitYlqxsb(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("提交成功");
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
			},
			// 查看  展开行效果
			toogleExpand(row) {
				// console.log("row==",row);
				if (row.sbsxType !== '4') {
					listOperation({busRecid:row.recid}).then(response => {
						this.chatLogs = response.rows;
					});
				} else {
					getYwzxsqOperation(row.recid).then(response => {
						this.ywzxsqOperation = response.data;
					});
				}
				const $table = this.$refs.table
				// 注意，这里的 this.list 是上面 data 中的 list
				// 通过比对数据与行里的数据，对展开行进行控制，获取对应值
				this.list.map((item) => {
					if (row.recid !== item.recid) {
						$table.toggleRowExpansion(item, false)
					}
				})
				$table.toggleRowExpansion(row)
			},
			
		}
	}
	
</script>

<style scoped="scoped">
	.box-card{
	}
	.row-content{
		text-align: left;
	}
	.el-radio-group{
		line-height: 1.875rem;
	}
	.content{
		margin-top: 0.9375rem;
	}
	.for-content{
		padding: 0.625rem;
	}
	.chat-time{
		line-height: 1.25rem;
		padding: 0.625rem 1.25rem;
		text-align: left;
	}
	.chat-content{
		line-height: 1.25rem;
		padding: 0.625rem 0 0 3rem;
		text-align: left;
		color: #7574aa;
	}
	.orgname{
		margin-top: 1rem;
		text-align: right;
		padding: 0 1rem 1rem 0;
	}
	.reply{
		color: #409EFF;
		cursor: pointer;
	}
	.chat-col{
		text-align: left;
		padding: 0.625rem;
	}
</style>
